/**
 * StoreBar Actions
 */

import * as types from './storeBarActionTypes';
import { ClubInfo } from '../../../components/Common/StoreBar/StoreBar.types';

/**
 * 获取共通店铺列表 - Request
 */
export const fetchCommonClubListRequest = (memberId: string) => ({
  type: types.FETCH_COMMON_CLUB_LIST_REQUEST,
  payload: memberId,
});

/**
 * 获取共通店铺列表 - Success
 */
export const fetchCommonClubListSuccess = (
  belongClubs: ClubInfo[],
  favoriteClubs: ClubInfo[],
  otherClubs: ClubInfo[],
) => ({
  type: types.FETCH_COMMON_CLUB_LIST_SUCCESS,
  payload: {
    belongClubs,
    favoriteClubs,
    otherClubs,
  },
});

/**
 * 获取共通店铺列表 - Failure
 */
export const fetchCommonClubListFailure = (error: string) => ({
  type: types.FETCH_COMMON_CLUB_LIST_FAILURE,
  payload: error,
});

// Action Types
export type StoreBarAction =
  | ReturnType<typeof fetchCommonClubListRequest>
  | ReturnType<typeof fetchCommonClubListSuccess>
  | ReturnType<typeof fetchCommonClubListFailure>;
